/**
 * @fileoverview Helper functions for using Summary in the Taskflow.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */

import {Summary} from '/src/com/yext/listingslaunchstorm/js/enterprise/summary/summary';
import {Task} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/task';
import {TaskIds} from '/src/com/yext/listingslaunchstorm/js/enterprise/taskflow/data/taskids';

import StackLargeSvg from '/src/com/yext/listingslaunchstorm/public/icons/stack-large.svg';

export const SummaryTask = new Task({
  id: TaskIds.SUMMARY,

  getPage: (enterpriseConfiguration, _setEnterpriseConfiguration, pageControls,
    hasChooseEntitiesAndListingsConfigSetup, publisherIds) => ({
    id: TaskIds.SUMMARY,
    layoutHeader: {
      icon: (<StackLargeSvg />),
      title: yext.msg('Summary'),
      description: yext.msg('Review the selections you have made before launching your listings. You can view each step again to change your selection.'),
    },
    content: (
      <Summary
        enterpriseConfiguration={enterpriseConfiguration}
        onViewStep={pageId => pageControls.setPage(pageId)}
        publisherIds={publisherIds}
      />
    ),
  }),

  getCard: (_enterpriseConfiguration, index, selectedPageId, setSelectedPageId, disabled) => ({
    id: TaskIds.SUMMARY,
    title: yext.msg('Summary'),
    index,
    isSelected: (selectedPageId === TaskIds.SUMMARY),
    onClick: disabled ? undefined : () => setSelectedPageId(TaskIds.SUMMARY),
    content: undefined,
  }),

  isComplete: _enterpriseConfiguration => true,
  isSectionSkipped: () => false,
});
